import type { SegmentTrackMainNavMenuClickEvent } from "@beautypie/segment/Track/MainNavMenuClick"
import cookie from "js-cookie"
import { track, trackClick as trackNavClick } from "tracking"
import { trackExperimentViewed } from "tracking/hooks/useExperimentViewed"
import { trackClickEvent } from "utils/gtm"
import type { ClickValueType } from "utils/gtm/types"

export const PAGE_EXPERIMENT_MERCH_CATEGORY_LIST_ORDER_JUNE24 =
  "page-experiment-merch-category-list-order-june24"

export let trackMerchExperiment = () => {
  const cookieValue = JSON.parse(cookie.get("experiment-flags") || "{}")[
    PAGE_EXPERIMENT_MERCH_CATEGORY_LIST_ORDER_JUNE24
  ]
  if (!cookieValue) return

  const value = cookieValue === "control" ? 0 : 1

  trackExperimentViewed(PAGE_EXPERIMENT_MERCH_CATEGORY_LIST_ORDER_JUNE24, value)

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  trackMerchExperiment = () => {}
}

export const trackClick = (label: ClickValueType, text: string): void => {
  const { href } = window.location

  if (label === "Search Menu Item Clicked") {
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "Search",
        location_type: "Input",
      },
    })
    return
  }

  if (label === "Open") {
    trackMerchExperiment()
  }

  trackNavClick({
    event: "Main Nav Menu Click",
    properties: {
      menu_category: label,
      click_text: text,
      click_url: href,
    },
  } as SegmentTrackMainNavMenuClickEvent)

  trackClickEvent({
    event: "Click",
    value: "Nav Click",
    label,
    clickText: text,
    clickUrl: href,
  })
}
